import React from 'react';

export default class Problem extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Problem I Want Treated</h1>
      <img src="/assets/images/step+1.jpeg" />
      <p>The process starts with the patient communicating the desire to address a problem. &nbsp;The problem may be one or more symptoms (low mood, insomnia, poor concentration) , a named medical condition (e.g. Major Depression, Mania, or Agoraphobia), or a functional problem (e.g. can't get my work done, not getting along with my family or friends, employment issues).</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Problem.js